@if (plugins() && plugin()) {
  @if (headerForm() && group()) {
    <formly-form class="plugin-header"
                 [title]="plugin().config?.description"
                 [model]="headerModel"
                 [form]="group()!"
                 [fields]="headerForm()!"
                 [options]="headerOptions" />
  } @else {
    <label [title]="plugin().config?.description">{{ plugin().config?.submitChild || plugin().name || plugin().tag }}</label>
  }
  @if (group()) {
    @if (children().length) {
      <div class="ribbon-margin" [style.margin-bottom.px]="childrenOn() * 20"></div>
    }
    @if (form() || promoteAdvanced() && advancedForm()) {
      <formly-form class="form plugin-content"
                   [model]="model()"
                   [form]="group()!"
                   [fields]="form() || advancedForm()!"
                   [options]="options" />
    }
    @if (advancedForm() && (form() || !promoteAdvanced())) {
      <details class="advanced {{ cssClass(plugin().tag) }}"
               [class.mini]="!form()"
               [class.header-toggle]="!!headerForm()">
        @if (form()) {
          <summary><span i18n>Advanced</span></summary>
        } @else {
          <summary i18n-title title="Advanced"><span></span></summary>
        }
        <formly-form class="form plugin-content"
                     [model]="model()"
                     [form]="group()!"
                     [fields]="advancedForm()!"
                     [options]="options" />
      </details>
    }
  }
  @for (child of children(); track child.tag) {
    @if (plugins().contains(child.tag)) {
      <hr>
      <div>
        <app-form-gen [plugins]="plugins()" [plugin]="child" [values]="values()" />
      </div>
    }
  }
}

<div class="floating-ribbons">
  @for (child of children(); track child.tag) {
    <div class="icon {{ cssClass(child.tag) }}"
         [class.on]="plugins().contains(child.tag)"
         (click)="toggleChild(child.tag)"><span>{{ child.config?.submitChild }}</span></div>
  }
</div>
